/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OrderDetailVo } from './OrderDetailVo';
import {
    OrderDetailVoFromJSON,
    OrderDetailVoFromJSONTyped,
    OrderDetailVoToJSON,
    OrderDetailVoToJSONTyped,
} from './OrderDetailVo';

/**
 * 
 * @export
 * @interface ResponseOrderDetailVo
 */
export interface ResponseOrderDetailVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseOrderDetailVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseOrderDetailVo
     */
    message?: string;
    /**
     * 
     * @type {OrderDetailVo}
     * @memberof ResponseOrderDetailVo
     */
    data?: OrderDetailVo;
}

/**
 * Check if a given object implements the ResponseOrderDetailVo interface.
 */
export function instanceOfResponseOrderDetailVo(value: object): value is ResponseOrderDetailVo {
    return true;
}

export function ResponseOrderDetailVoFromJSON(json: any): ResponseOrderDetailVo {
    return ResponseOrderDetailVoFromJSONTyped(json, false);
}

export function ResponseOrderDetailVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseOrderDetailVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : OrderDetailVoFromJSON(json['data']),
    };
}

export function ResponseOrderDetailVoToJSON(json: any): ResponseOrderDetailVo {
    return ResponseOrderDetailVoToJSONTyped(json, false);
}

export function ResponseOrderDetailVoToJSONTyped(value?: ResponseOrderDetailVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': OrderDetailVoToJSON(value['data']),
    };
}

